<template>
  <OAccordion
    v-model="onOpen"
    header-class="min-h-44"
    class="bg-card-100 border border-neutral-100/10 overflow-hidden !rounded-md col-span-2 shrink-0"
  >
    <template #header>
      <p class="w-full text-paragraph-2 text-neutral-70 self-center">
        {{ textHeader }}
      </p>
    </template>

    <div class="p-16">
      <p class="text-paragraph-3 text-neutral-70">
        {{ description }}
      </p>
    </div>
  </OAccordion>
</template>

<script></script>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import OAccordion from './OAccordion.vue'

const { t } = useI18n()

const props = defineProps({
  description: String,
})

const onOpen = ref(false)
const textHeader = computed(() => {
  return onOpen.value ? t('viewLess') : t('viewMore')
})
</script>

<style lang="scss" scoped></style>
